<template>
  <div style="height: 100%;">
    <my-header>
      选择题
    </my-header>
    <video ref="input_video" width="100%" height="100%" style="display: none;"></video>
    <div style="position:relative;">
      <canvas
          class="output_canvas"
          ref="output_canvas"
          :width="width"
          :height="height"
      ></canvas>
      <canvas
          class="output_canvas"
          ref="take_photo_canvas"
          :width="width"
          :height="height"
      ></canvas>
    </div>
  </div>
</template>
<script>
import { Hands, HAND_CONNECTIONS } from "@mediapipe/hands";
import { Pose, POSE_CONNECTIONS } from "@mediapipe/pose";
import { Camera } from "@mediapipe/camera_utils";
import { drawConnectors, drawLandmarks } from "@mediapipe/drawing_utils";
import { Field, Button, Toast, Cell, CellGroup, Row, Col, Grid, GridItem, Dialog } from 'vant'
import {checkVictory, CheckLeftStroke, CheckRightStroke} from '@/utils/mediapipe'
import { saveFaceImage } from '@/api'

export default {
  name: "HandModel",
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button
  },
  data: function() {
    return {
      camera: null,
      number: null,
      ctx: null,
      handsCtx: null,
      width: null,
      height: null,
      handsImage: '',
      uploading: false,
      loading: 0,
      leftHandsLine: [],
      rightHandsLine: [],
    };
  },
  computed: {
    inputVideo() {
      return this.$refs.input_video;
    },
  },
  mounted() {
    this.ctx = this.$refs.output_canvas.getContext("2d");
    this.handsCtx = this.$refs.take_photo_canvas.getContext("2d");
    this.init();
  },
  methods: {
    init() {
      this.handsImage = new Image();
      this.handsImage.src = require('@/assets/hands.png');
      window.requestAnimationFrame(this.pose);
    },
    pose() {
      const pose = new Pose({
        locateFile: (file) => {
          console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/pose@0.5.1635988162/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/pose@0.5.1635988162/${file}`;
        },
      });
      pose.setOptions({
        modelComplexity: 1,
        smoothLandmarks: true,
        enableSegmentation: true,
        smoothSegmentation: true,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      pose.onResults(this.onResults);


      const hands = new Hands({
        locateFile: (file) => {
          // console.log(file)
          // return `http://localhost:8080/static/@mediapipe/hands@0.4.1646424915/${file}`;

          // 只有这个固定版本正常，更高的版本都报错，暂时不知道原因
          return `/static/@mediapipe/hands@0.3.1632795355/${file}`;
          return `https://cdn.jsdelivr.net/npm/@mediapipe/hands@0.3.1632795355/${file}`;
        },
      });
      hands.setOptions({
        maxNumHands: 1,
        minDetectionConfidence: 0.5,
        minTrackingConfidence: 0.5,
      });
      hands.onResults(this.onHandsResults);

      this.camera = new Camera(this.inputVideo, {
        onFrame: async () => {
          await pose.send({ image: this.inputVideo })
          await hands.send({ image: this.inputVideo })
        },
      })
      this.camera.start()
    },
    onResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;
      this.ctx.save();
      this.ctx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.ctx.translate(results.image.width, 0);
      this.ctx.scale(-1, 1);
      // console.log(results.image)
      this.ctx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      if (results.poseLandmarks) {

        if(results.poseLandmarks[19]['visibility'] > 0.8){

          this.leftHandsLine.push(results.poseLandmarks[19])
          if(this.leftHandsLine.length > 10){
            this.leftHandsLine.shift()

            CheckLeftStroke(results.poseLandmarks, this.leftHandsLine).then(res => {
              this.leftHandsLine = []
              Toast('识别左手往右划')
            }).catch(err => {
              console.log(err)
            })
          }
        }

        if(results.poseLandmarks[20]['visibility'] > 0.8){

          this.rightHandsLine.push(results.poseLandmarks[20])
          if(this.rightHandsLine.length > 10){
            this.rightHandsLine.shift()

            CheckRightStroke(results.poseLandmarks, this.rightHandsLine).then(res => {
              this.rightHandsLine = []
              Toast('识别右手往左划')
            }).catch(err => {
              console.log(err)
            })
          }
        }

        drawConnectors(this.ctx, results.poseLandmarks, POSE_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 4,
        });
        drawLandmarks(this.ctx, results.poseLandmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
        // }
      }
      this.ctx.restore();
      this.ctx.font = '80px STheiti, SimHei'
      this.ctx.fillStyle = "green"

      // const dataURL = this.$refs.output_canvas.toDataURL('image/png')

    },
    onHandsResults(results) {
      this.width = results.image.width;
      this.height = results.image.height;

      this.handsCtx.save();
      this.handsCtx.clearRect(0, 0, results.image.width, results.image.height);
      // 下面两句翻转
      this.handsCtx.translate(results.image.width, 0);
      this.handsCtx.scale(-1, 1);
      this.handsCtx.drawImage(
          results.image,
          0,
          0,
          results.image.width,
          results.image.height
      );

      for (const landmarks of results.multiHandLandmarks) {
        drawConnectors(this.handsCtx, landmarks, HAND_CONNECTIONS, {
          color: "#00FF00",
          lineWidth: 5,
        });
        drawLandmarks(this.handsCtx, landmarks, {
          color: "#FF0000",
          lineWidth: 2,
        })
      }
      // this.findHands(results);
      this.handsCtx.restore();

      if (results.multiHandLandmarks) {
        for (const landmarks of results.multiHandLandmarks) {
          checkVictory(landmarks).then(res => {
            this.saveFaceImage()
          }).catch(err => {
            console.log(err)
          })
          break
        }
      }
      this.handsCtx.restore();
      this.handsCtx.save();
    },
    saveFaceImage(){
      if(this.uploading){
        return
      }
      Toast('照片生成中。。。')
      this.uploading = true
      this.$refs.take_photo_canvas.toBlob((blob)=>{
        // console.log(blob)
        const formData = new FormData()
        formData.append('file', blob)
        formData.append('select_id', 1)
        saveFaceImage(formData).then(res => {
          Toast('照片上传成功！')
          console.log(res)
          this.uploading = false
        }).catch(err => {
          Toast('照片上传失败！')
          this.uploading = false
        })
      },'image/png')
    }
  },
  beforeRouteLeave(to, from, next) {
    this.camera.stop()
    next()
  }
}
</script>

<style scoped>
.output_canvas {
  width: 100%;
  height: 100%;
}
.question{
  position: absolute;
  text-align: center;
  width: 100%;
  font-size: 5rem;
}
</style>
<style>
.van-grid-item__content{
  background-color: transparent;
}
</style>
